import usFlag from "../assets/images/flags/us.jpg"
import kuwaitFlag from "../assets/images/flags/kuwait.svg"
// import spain from "../assets/images/flags/spain.jpg"
// import germany from "../assets/images/flags/germany.jpg"
// import italy from "../assets/images/flags/italy.jpg"
// import russia from "../assets/images/flags/russia.jpg"

const languages = {
  en: {
    label: "English",
    flag: usFlag,
  },
  om: {
    label: "Arabic",
    flag: kuwaitFlag,
  },
};

export default languages
